import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'sdDistanceFromYou',
  standalone: true,
})
export class DistanceFromYouPipe implements PipeTransform {
  transform(distanceInKm: number): string {
    if (distanceInKm < 1) {
      const distanceInMeters = Math.round(distanceInKm * 100) * 10;

      return `${distanceInMeters} м`;
    }

    return `${Number(distanceInKm.toFixed(1))} км`;
  }
}
